import { Navigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import Loading from '@/components/content/loading/Loading';
import ErrorWrapper from '@/components/content/error/ErrorWrapper';

import { openApiFetch } from '@/lib/openapi-fetch';
import { UnifiedApiPaths } from '@/types/mercury-data-types/unifiedapi';
import { INCIDENTS_ENDPOINTS } from '../services/keys';
import { joinApiPath } from '@/lib/apiPath';

const CommonIssue = () => {
  const { issue } = useParams();
  const issueId = +(issue as string);

  const baseQuery = (path: UnifiedApiPaths) =>
    useQuery({
      queryKey: [path],
      queryFn: () =>
        openApiFetch(path, {
          params: {
            path: { resource_id: issueId },
          },
        }),
      gcTime: 0,
      staleTime: 0,
    });

  const incidentsQuery = baseQuery(
    joinApiPath(INCIDENTS_ENDPOINTS.incidents, '{resource_id}') as any
  );
  const takedownsQuery = baseQuery(
    joinApiPath(INCIDENTS_ENDPOINTS.takedowns, '{resource_id}') as any
  );

  return (
    <ErrorWrapper isError={incidentsQuery.isError && takedownsQuery.isError}>
      <Loading
        text="Loading ticket"
        height="calc(100vh - calc(var(--app-shell-header-offset, 0rem) + var(--app-shell-padding)))"
      />

      {incidentsQuery.isSuccess && <Navigate to={`/incidentmanagement/alert/issue/${issueId}`} />}

      {takedownsQuery.isSuccess && (
        <Navigate to={`/incidentmanagement/takedown/issue/${issueId}`} />
      )}
    </ErrorWrapper>
  );
};

export default CommonIssue;
